import { BlocksHeading } from 'blocks-nextjs/blocks-web-components/components/heading/heading';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatHeading = createComponent({ react: React, tagName: 'cat-heading', elementClass: BlocksHeading });
